import React, { useEffect, useContext } from 'react';
import {HashRouter, Switch, Route} from 'react-router-dom';
import {PrivateRoute} from './PrivateRoute';
import { useSelector, useDispatch } from 'react-redux';
import { startGoogleLogin } from 'src/redux/actions/auth';
import { axiosAuthGetNoState } from 'src/helpers/axios/AxiosRequest';
import { GlobalContext } from 'src/context/GlobalContext';
import '../scss/style.scss';

const loading = (
    <div className="text-center mt-5">
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
  )

// Containers
const TheLayout = React.lazy(() => import('../containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('../views/pages/login/Login'));
const LoginCallback = React.lazy(() => import('../views/pages/login/LoginCallback'));
const GoogleLogin = React.lazy(() => import('../views/pages/login/GoogleLogin'));
const Page401 = React.lazy(() => import('../views/pages/page401/Page401'));
const Page404 = React.lazy(() => import('../views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('../views/pages/page500/Page500'));
const ControlEscolarApp = React.lazy(() => import('../views/controlescolar/ControlEscolarApp'));
const AdministracionApp = React.lazy(() => import('../views/administracion/AdministracionApp'));
const ClinicasApp = React.lazy(() => import('../views/clinicas/ClinicasApp'));
const ConfiguracionApp = React.lazy(() => import('../views/configuracion/ConfiguracionApp'));
const IngresosApp = React.lazy(() => import('../views/ingresos/IngresosApp'));
const CoordacadApp = React.lazy(() => import('../views/coordacad/CoordacadApp'));
const EduContinuaApp = React.lazy(() => import('../views/educontinua/EduContinuaApp'));
const AboutApp = React.lazy(() => import('../views/about/AboutApp'));

export const AppRouter = () => {
    const {isLoggedIn} = useSelector(state => state.auth);
    const lastPath = localStorage.getItem('lastPath') || '/dashboard';
    const dispatch = useDispatch();
    const {BACKEND_URL} = useContext(GlobalContext);

    useEffect(() => {
        // Check in store state
        if(isLoggedIn === false){
            // Page Reload? Check on LocalStorage
            const localSession = localStorage.getItem('isLoggedIn') || false;
            const token = localStorage.getItem('token') || '';

            if(localSession && token !== ''){
                //Obtenemos información adicional del usuario   
                const url= `${BACKEND_URL}/configuracion/user`;
                let request = axiosAuthGetNoState(url, token);
                request.then(function(data){
                    if(data && data.data){
                        //Vamos por roles
                        const urlRoles= `${BACKEND_URL}/configuracion/users/myRoles/${data.data.id}`;
                        let requestRoles = axiosAuthGetNoState(urlRoles, token);
                        requestRoles.then(function(dataRoles){
                            //console.log(dataRoles);
                            //Guardamos todo
                            let theRoles = (dataRoles.data.data.roles) ? dataRoles.data.data.roles : [];
                            dispatch(startGoogleLogin(data.data.name, token, data.data.avatar, data.data.email, theRoles));
                        });
                    }else{
                        window.location = "#/login";
                    }
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    return (
        <div>
            <HashRouter>
                <React.Suspense fallback={loading}>
                    <Switch>
                    <Route exact path="/401" name="Page 401" render={props => <Page401 {...props} />} />
                    <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
                    <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
                    <Route exact path="/login" name="Login" render={props => <Login {...props} />} lastPath={lastPath} isAuthenticated={isLoggedIn} />
                    <Route exact path="/loginCallback" name="Login" render={props => <LoginCallback {...props} />} lastPath={lastPath} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/about" name="About" component={props => <AboutApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/controlescolar" name="Control Escolar" component={props => <ControlEscolarApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/ingresos" name="Inscripciones y reinscripciones" component={props => <IngresosApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/coordacad" name="Coordinación académica" component={props => <CoordacadApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/administracion" name="Administracion" component={props => <AdministracionApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/configuracion" name="Configuración" component={props => <ConfiguracionApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/educontinua" name="Educación continua" component={props => <EduContinuaApp {...props} />} isAuthenticated={isLoggedIn} />
                    <PrivateRoute path="/clinicas" name="Clinicas" component={props => <ClinicasApp {...props} />} isAuthenticated={isLoggedIn} />
                    <Route path='/auth/google' render={props => <GoogleLogin {...props} />}/>
                    
                    {/* no poner nada debajo de esta ruta TODO ARRIBA  */}
                    <PrivateRoute path="/" name="Inicio" component={props => <TheLayout {...props} />} isAuthenticated={isLoggedIn} />
                    </Switch>
                </React.Suspense>
            </HashRouter>
        </div>
    )
}